import React from 'react';

const PaletteSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      {...props}
    >
      <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="currentColor" stroke="none">
        <path d="M3950 5104 c-36 -7 -103 -32 -150 -55 -79 -39 -100 -57 -315 -270 l-230 -228 445 -446 445 -445 226 227 c247 249 280 294 318 433 25 91 28 238 6 325 -44 173 -168 327 -325 404 -139 68 -277 86 -420 55z"/>
        <path d="M2795 4444 c-44 -23 -323 -303 -346 -346 -24 -47 -24 -89 0 -136 24 -46 1064 -1084 1108 -1106 43 -21 86 -20 131 3 45 24 324 304 346 348 21 43 20 86 -3 131 -24 46 -1064 1084 -1108 1106 -40 20 -89 20 -128 0z"/>
        <path d="M1813 2905 c-474 -479 -625 -638 -650 -682 -36 -65 -63 -158 -63 -217 0 -36 -8 -47 -93 -135 -120 -124 -142 -167 -141 -281 0 -100 24 -160 89 -225 65 -65 125 -89 225 -89 114 0 158 22 281 141 78 76 102 93 126 93 53 0 133 19 197 47 56 24 112 77 699 662 l637 636 -337 337 c-186 186 -341 338 -345 338 -3 0 -285 -281 -625 -625z"/>
        <path d="M814 1166 c-80 -35 -312 -374 -376 -550 -27 -74 -30 -90 -26 -176 6 -121 40 -202 123 -289 147 -154 364 -192 554 -98 58 28 155 118 186 172 119 203 82 388 -142 713 -158 227 -219 271 -319 228z"/>
      </g>
    </svg>
  );
};

export { PaletteSVG };
